import styled from "@emotion/styled";

export const PositionedButton = styled.button`
  position: absolute;

  left: calc(var(--x) - 0.5 * var(--size));
  top: calc(var(--y) - 0.5 * var(--size));

  width: var(--size);
  height: var(--size);

  border-radius: 50%;

  &:focus {
    outline: none;
  }

  > svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
